import { cn } from '@/lib/utils';

/**
 * The small amber count that marks something waiting on a person — a pending request, an
 * unreviewed change. Distinct from `Badge`, which labels what a thing *is*: this one says how
 * much of it is outstanding, and disappears entirely at zero so a quiet item stays undecorated.
 *
 * `onFilled` is for a selected nav row or segment, where amber-on-primary would fight the
 * surface it sits on.
 */
export function AttentionBadge({
  count,
  tone = 'default',
  label,
  className,
}: {
  count: number | undefined;
  tone?: 'default' | 'onFilled';
  /** What the number counts, for screen readers — a bare digit announces nothing useful. */
  label?: string;
  className?: string;
}) {
  if (!count || count <= 0) return null;

  return (
    <span
      aria-label={label}
      className={cn(
        'inline-flex h-5 min-w-5 shrink-0 items-center justify-center rounded-full px-1.5 text-[11px] font-semibold tabular-nums',
        tone === 'onFilled' ? 'bg-primary-foreground/20 text-primary-foreground' : 'bg-amber-500 text-white',
        className
      )}
    >
      {count}
    </span>
  );
}
